export default __webpack_public_path__ + "static/media/Error404.ee48aa3e.png";